import { Company } from '../../models/context.model';
import { IAvatarFactory } from './avatar-factory.interface';

export class CompanyAvatarFactory implements IAvatarFactory {
	constructor(private company: Company) {}

	public getRandomColor(colors: string[]): string {
		return colors[(this.company.Id || 0) % colors.length];
	}

	public getLetter(): string {
		let letter = '*';

		if (this.company.Name && this.company.Name.trim().length) {
			letter = this.company.Name.trim()[0];
		}

		return letter.toUpperCase();
	}
	public getImagePath(): string {
		return '';
	}
}
